<div class="detalhe-page" [class.lightbox-aberto]="lightboxAberto" *ngIf="produto">
  <!-- Corpo principal (scrollavel) -->
  <div class="detalhe-body">
    <!-- Layout desktop: imagem a esquerda, detalhes a direita -->
    <div class="detalhe-layout">
      <!-- Coluna da imagem: galeria (principal + secundarias do item) -->
      <div class="detalhe-img-col">
        <div class="detalhe-img-wrapper">
          <!--
            Galeria reutilizando o carrossel compartilhado. Ele busca as imagens
            secundarias sozinho via GET /item/{id}/imagens (ItemImagemService) e
            faz degrade gracioso: se a chamada falhar ou retornar vazia, exibe
            apenas a imagem principal (produto.foto). A foto principal ja vem como
            URL absoluta, entao e passada direto (passthrough no carrossel).
          -->
          <app-item-imagens-carrossel
            [itemId]="produto.id"
            [imagemPrincipalUrl]="produto.foto || undefined"
            [idEmpresa]="idEmpresa"
            [alt]="produto.nome"
            [mostrarMiniaturas]="true"
            posicaoMiniaturas="left"
            tema="publico-cardapio"
            (lightboxAbertoChange)="lightboxAberto = $event">
          </app-item-imagens-carrossel>
        </div>
      </div>

      <!-- Coluna de detalhes -->
      <div class="detalhe-details-col">
        <!-- Nome do item + compartilhar (acima do preco) -->
        <div class="detalhe-head">
          <div class="detalhe-titulo-row">
            <h2 class="detalhe-nome">{{ produto.nome }}</h2>
            <button class="detalhe-share-btn"
                    type="button"
                    (click)="onCompartilhar()"
                    [attr.aria-label]="'cardapio_digital.compartilhar' | translate"
                    [attr.title]="'cardapio_digital.compartilhar' | translate">
              <i class="pi pi-share-alt"></i>
            </button>
          </div>

          <div class="detalhe-precos">
            <span class="detalhe-preco">
              {{ precoPromocionalFormatado || precoFormatado }}
            </span>
            <span *ngIf="precoPromocionalFormatado"
                  class="detalhe-preco-original">
              {{ precoFormatado }}
            </span>
            <span *ngIf="produto.percentualDesconto"
                  class="detalhe-desconto-badge">
              -{{ produto.percentualDesconto }}%
            </span>
            <span *ngIf="produto.novidade" class="detalhe-selo detalhe-selo--icone selo-novidade"
                  [attr.aria-label]="'cardapio_digital.badge_novidade' | translate"
                  [pTooltip]="'cardapio_digital.badge_novidade' | translate" tooltipPosition="top">
              <i class="pi pi-star-fill"></i>
            </span>
            <span *ngIf="produto.promocao" class="detalhe-selo detalhe-selo--icone selo-promocao"
                  [attr.aria-label]="'cardapio_digital.badge_promocao' | translate"
                  [pTooltip]="'cardapio_digital.badge_promocao' | translate" tooltipPosition="top">
              <i class="fas fa-tag"></i>
            </span>
          </div>
        </div>

        <!-- Secao de variantes (ex: tamanho, sabor) -->
        <ng-container *ngIf="temVariantes">
          <div class="detalhe-grupos">
            <div class="detalhe-grupo">
              <div class="detalhe-grupo-header">
                <div class="detalhe-grupo-info">
                  <span class="detalhe-grupo-nome">{{ 'cardapio_digital.variantes' | translate }}</span>
                  <span class="detalhe-grupo-desc">
                    {{ 'cardapio_digital.selecione_variante' | translate }}
                  </span>
                </div>
                <div class="detalhe-grupo-acoes">
                  <span *ngIf="varianteSelecionada" class="detalhe-grupo-completo">
                    {{ 'cardapio_digital.concluido' | translate }}
                  </span>
                  <span *ngIf="!varianteSelecionada" class="detalhe-grupo-obrigatorio">
                    {{ 'cardapio_digital.obrigatorio' | translate }}
                  </span>
                </div>
              </div>

              <div class="detalhe-opcoes">
                <div *ngFor="let variante of produto.variantes; let last = last"
                     class="detalhe-opcao-radio"
                     (click)="selecionarVariante(variante)">
                  <div class="detalhe-opcao-radio-info">
                    <span class="detalhe-opcao-nome">{{ variante.nome }}</span>
                    <span class="detalhe-opcao-preco">
                      {{ formatarPrecoVariante(variante) }}
                    </span>
                  </div>
                  <span class="detalhe-radio-indicator"
                        [class.checked]="isVarianteSelecionada(variante.id)">
                    <span *ngIf="isVarianteSelecionada(variante.id)" class="detalhe-radio-dot"></span>
                  </span>
                  <div *ngIf="!last" class="detalhe-opcao-separator"></div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Grupos de modificadores -->
        <ng-container *ngIf="temModificadores">
          <div class="detalhe-grupos">
            <div *ngFor="let grupo of produto.modificadores; trackBy: trackByGrupo" class="detalhe-grupo">
              <!-- Header colapsavel do grupo -->
              <div class="detalhe-grupo-header" (click)="toggleGrupo(grupo.id)">
                <div class="detalhe-grupo-info">
                  <span class="detalhe-grupo-nome">{{ grupo.nome }}</span>
                  <span class="detalhe-grupo-desc">
                    <ng-container *ngIf="grupo.obrigatorio">
                      {{ 'cardapio_digital.selecione_minimo' | translate }} {{ grupo.minimoSelecoes }}
                    </ng-container>
                    <ng-container *ngIf="grupo.maximoSelecoes > 1">
                       · {{ 'cardapio_digital.selecione_ate' | translate }} {{ grupo.maximoSelecoes }}
                    </ng-container>
                  </span>
                </div>
                <div class="detalhe-grupo-acoes">
                  <span *ngIf="isGrupoCompleto(grupo)" class="detalhe-grupo-completo">
                    {{ 'cardapio_digital.concluido' | translate }}
                  </span>
                  <span *ngIf="grupo.obrigatorio && !isGrupoCompleto(grupo)" class="detalhe-grupo-obrigatorio">
                    {{ 'cardapio_digital.obrigatorio' | translate }}
                  </span>
                  <i class="pi" [class.pi-chevron-up]="isGrupoAberto(grupo.id)" [class.pi-chevron-down]="!isGrupoAberto(grupo.id)"></i>
                </div>
              </div>

              <!-- Opcoes do grupo (colapsavel) -->
              <div class="detalhe-opcoes" *ngIf="isGrupoAberto(grupo.id)">
                <!-- Tipo RADIO: lista vertical -->
                <ng-container *ngIf="grupo.maximoSelecoes === 1">
                  <div *ngFor="let opcao of grupo.opcoes; let last = last; trackBy: trackByOpcao"
                       class="detalhe-opcao-radio"
                       (click)="toggleOpcao(grupo, opcao)">
                    <div class="detalhe-opcao-radio-info">
                      <span class="detalhe-opcao-nome">{{ opcao.nome }}</span>
                      <span *ngIf="opcao.precoAdicional > 0" class="detalhe-opcao-preco">
                        {{ formatarPrecoOpcao(opcao.precoAdicional) }}
                      </span>
                    </div>
                    <span class="detalhe-radio-indicator"
                          [class.checked]="isOpcaoSelecionada(grupo.id, opcao.id)">
                      <span *ngIf="isOpcaoSelecionada(grupo.id, opcao.id)" class="detalhe-radio-dot"></span>
                    </span>
                    <div *ngIf="!last" class="detalhe-opcao-separator"></div>
                  </div>
                </ng-container>

                <!-- Tipo MULTI-SELECT: lista vertical com controle de quantidade -->
                <ng-container *ngIf="grupo.maximoSelecoes > 1">
                  <div *ngFor="let opcao of grupo.opcoes; let last = last; trackBy: trackByOpcao"
                       class="detalhe-opcao-multi">
                    <div class="detalhe-opcao-multi-info">
                      <span class="detalhe-opcao-nome">{{ opcao.nome }}</span>
                      <span *ngIf="opcao.precoAdicional > 0" class="detalhe-opcao-preco">
                        {{ formatarPrecoOpcao(opcao.precoAdicional) }}
                      </span>
                    </div>
                    <!-- Nao selecionada: botao + -->
                    <button *ngIf="!isOpcaoSelecionada(grupo.id, opcao.id)"
                            class="detalhe-multi-btn-add"
                            type="button"
                            (click)="incrementarOpcao(grupo, opcao, $event)">
                      <i class="pi pi-plus"></i>
                    </button>
                    <!-- Selecionada: controle -/qty/+ -->
                    <div *ngIf="isOpcaoSelecionada(grupo.id, opcao.id)"
                         class="detalhe-multi-qty">
                      <button class="detalhe-multi-qty-btn"
                              type="button"
                              (click)="decrementarOpcao(grupo, opcao, $event)">
                        <i class="pi pi-minus"></i>
                      </button>
                      <span class="detalhe-multi-qty-value">{{ getQuantidadeOpcao(grupo.id, opcao.id) }}</span>
                      <button class="detalhe-multi-qty-btn"
                              type="button"
                              (click)="incrementarOpcao(grupo, opcao, $event)">
                        <i class="pi pi-plus"></i>
                      </button>
                    </div>
                    <div *ngIf="!last" class="detalhe-opcao-separator"></div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Informacoes do item (categoria, indicado, genero) — apos variantes/modificadores -->
        <ul *ngIf="categoriaNome || produto.indicado || generoLabelKey"
            class="detalhe-infos">
          <li *ngIf="categoriaNome" class="detalhe-info-linha">
            <span class="detalhe-info-label">{{ 'cardapio_digital.detalhe_categoria' | translate }}:</span>
            <span class="detalhe-info-valor">{{ categoriaNome }}</span>
          </li>
          <li *ngIf="produto.indicado" class="detalhe-info-linha">
            <span class="detalhe-info-label">{{ 'cardapio_digital.detalhe_indicado' | translate }}:</span>
            <span class="detalhe-info-valor">{{ produto.indicado }}</span>
          </li>
          <li *ngIf="generoLabelKey" class="detalhe-info-linha">
            <span class="detalhe-info-label">{{ 'cardapio_digital.detalhe_genero' | translate }}:</span>
            <span class="detalhe-info-valor">{{ generoLabelKey | translate }}</span>
          </li>
        </ul>

        <!-- Descricao do item (por ultimo, com titulo) -->
        <div class="detalhe-descricao-secao" *ngIf="produto.descricao">
          <h3 class="detalhe-descricao-titulo">{{ 'cardapio_digital.descricao_titulo' | translate }}</h3>
          <p class="detalhe-descricao">{{ produto.descricao }}</p>
        </div>

        <!-- Espaco para o footer fixo nao sobrepor conteudo -->
        <div class="detalhe-footer-spacer"></div>
      </div>
    </div>
  </div>

  <!-- Footer fixo -->
  <div class="detalhe-footer">
    <div class="detalhe-qty-controls">
      <button class="detalhe-btn-qty" (click)="decrementar()" [disabled]="quantidade <= 1">
        <i class="pi pi-minus"></i>
      </button>
      <span class="detalhe-qty-value">{{ quantidade }}</span>
      <button class="detalhe-btn-qty" (click)="incrementar()" [disabled]="quantidade >= maxQuantidade">
        <i class="pi pi-plus"></i>
      </button>
    </div>
    <button class="detalhe-btn-adicionar" [disabled]="!podeConfirmar" (click)="onConfirmar()">
      <ng-container *ngIf="!semEstoqueDisponivel; else semEstoque">
        <span>{{ 'cardapio_digital.adicionar' | translate }}</span>
        <span class="detalhe-btn-preco">{{ precoTotalFormatado }}</span>
      </ng-container>
      <ng-template #semEstoque>
        <span>{{ 'cardapio_digital.sem_estoque' | translate }}</span>
      </ng-template>
    </button>
  </div>
</div>
